<template>
    <div class="list-position">
        <button @click="toTop(0)" class="iconfont icon-zhiding"></button>
        <button @click="toTop(1)" class="iconfont icon-zhiding"></button>
    </div>
</template>
<script>
import $store from '../store'
export default {
    data(){
        return{
            timer:null
        }
    },
    methods:{
        toTop(type){
            $store.commit('SETSCROLLTIMER',{fn:this.setScroll,type:type})
        },
        setScroll(type){
            var curHeight = document.documentElement.scrollTop || document.body.scrollTop;
            var now = curHeight;
            var aims = type ? document.documentElement.scrollHeight - window.innerHeight : 0
            var speed = type ? Math.ceil((aims - now) / 5) : Math.floor((aims - now) / 5);
            if (curHeight === aims) {
                clearInterval(this.timer);
            }
            document.documentElement.scrollTop = curHeight + speed;
            document.body.scrollTop =  curHeight + speed; 
        }
    },
    mounted(){
        document.addEventListener('DOMMouseScroll',()=>{
            $store.commit('SETSCROLLTIMER')
        },false);
        window.onmousewheel=document.onmousewheel=()=>{
            $store.commit('SETSCROLLTIMER')
        };
    }
}
</script>

<style lang="less" scoped>
.list-position{
    width: 50px;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0 5px 11px 0 #D9E5F6;
    border-radius: 4px;
    position: fixed;
    right: 0;
    bottom: 40px;
    z-index: 10;
}
.list-position button{
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
    color: #666666;
    cursor: pointer;
    background: #ffffff;
    color: rgb(139, 151, 221);
    border: none;
    outline: none;
}
.list-position button:nth-of-type(1){
    transform: rotate(180deg);
}
.list-position button:nth-of-type(2){
    border-top: 1px solid #E2E2E2;
}
.list-position button:hover{
    color: #5A75F6;
}
</style>




// WEBPACK FOOTER //
// packages/question-assembly/src/toTop.vue